const parsePartSupplierPricebreaks = (part_supplier, exact_qty, minimum_order_qty, markup) => {
  if(!part_supplier || _.isEmpty(part_supplier)) return []

  const first_valid_pricebreak = best_pricebreak(part_supplier.pricebreaks, minimum_order_qty, false)

  let pricebreaks = []
  if(first_valid_pricebreak){
    pricebreaks.push({
      type: 'single',
      id: first_valid_pricebreak.id,
      qty: minimum_order_qty,
      extra_parts: minimum_order_qty - exact_qty,
      price: (first_valid_pricebreak.price * (1 + markup)),
      pricebreak: _.cloneDeep(first_valid_pricebreak),
    })
  }

  part_supplier.pricebreaks.filter((p) => p.qty > minimum_order_qty && p.qty <= part_supplier.stock).forEach((p) => {
    pricebreaks.push({
      type: 'single',
      id: p.id,
      qty: p.qty,
      extra_parts: p.qty - exact_qty,
      price: (p.price * (1 + markup)),
      pricebreak: _.cloneDeep(p),
    })
  })

  return pricebreaks
}

const parsePricebreaksFromPartSupplierSelections = (part_supplier_selections, board_qty, exact_qty, order_qty, markup) => {
  return []
}

export const parsePricebreaksFromPart = (selected_part, selected_part_supplier, board_qty, exact_qty, order_qty, markup) => {
  if(!selected_part || _.isEmpty(selected_part)) return []
  
  return selected_part.ps_selections && selected_part.ps_selections[board_qty] && selected_part.ps_selections[board_qty].length > 0 ? 
    parsePricebreaksFromPartSupplierSelections(selected_part.ps_selections[board_qty], board_qty, exact_qty, order_qty, markup) : 
    parsePartSupplierPricebreaks(selected_part_supplier, exact_qty, order_qty, markup)
}

export const best_pricebreak = (pricebreaks, quantity, check_next=true) => {
  var bp = null
  var validate_next = false

  pricebreaks.map((pricebreak) =>{
    if (pricebreak.qty <= quantity){
      bp = pricebreak
    }else{
      // Check if the next pricebreak is cheaper than the selected
      if(check_next){
        if(!validate_next && !isEmpty(bp) &&
          ((bp.price * quantity) > (pricebreak.price * pricebreak.qty))){
          bp = pricebreak
        }
        validate_next = true
      }
    }
  });

  return bp;
}


